import { Imprint } from 'components/Imprint';

const ScreenImprint = () => <Imprint />;

export default ScreenImprint;
